import { api } from '@/services/api'

export class PracticeService {
    async getAvailableSurveyVersions() {
        try {
            return await api.get('web.practice/get_available_survey_versions/')
        } catch (e) {
            console.log('error in getAvailableSurveyVersions', e.response?.status, e.response?.data)
            return {}
        }
    }
}

export const practiceService = new PracticeService()
